<template>
  <section class="body-section">
    <component :is="loginOrRegister" />
  </section>
</template>

<script>
import RegisterUser from "../components/authenticate/RegisterUser";
import LoginUser from "../components/authenticate/LoginUser";
import LostPassword from "../components/authenticate/LostPassword";

export default {
  components: { RegisterUser, LoginUser, LostPassword },
  props: {
    isNewUser: {
      type: Boolean,
      default: false,
    },

    isLostPassword: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loginOrRegister() {
      if (this.isLostPassword == true) {
        return "LostPassword";
      }
      return !this.isNewUser ? "LoginUser" : "RegisterUser";
    },
  },
};
</script>
